let forms;
let form1;
let form2;
let form3;
let form4;
let form5;

let forwards;
let backs;
let submit;

let addMarket;
let markets = [];
let marketsAdded = false;

let currentPage = 0;
let pageTopics = [
    "@Model.CompanyTitleLabel.RawValue",
    "@Model.ContactPersonTitleLabel.RawValue",
    "@Model.MotivationTitleLabel.RawValue",
    "@Model.ExportTitleLabel.RawValue",
    "@Model.SummaryTitleLabel.RawValue"
];

let numberOfMarketInput = 2;

let companyChecker = false;
let motivationChecker = false;

window.addEventListener("DOMContentLoaded", event => {
    function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(
            newNode,
            referenceNode.nextSibling
        );
    }

    function setCurrentPage(page) {
        currentPage = page;
    }

    function hideAll() {
        for (const element of forms) {
            element.style.display = "none";
            element.classList.remove("active-form");
        }
    }

    function hideAllErrors(errors, labels, inputs) {
        if (errors) {
            for (let i = 0; i < errors.length; i++) {
                errors[i].style.display = "none";
            }
        }
        if (labels) {
            for (let i = 0; i < labels.length; i++) {
                labels[i].style.color = "#4f7d4c";
            }
        }
        if (inputs) {
            for (let i = 0; i < inputs.length; i++) {
                inputs[i].style.border = "#4f7d4c thin solid";
            }
        }
    }

    function showForm(page) {
        forms[page].style.display = "block";
        forms[page].classList.add("active-form");
        document
            .getElementById("scrollpoint")
            .scrollIntoView({ behavior: "smooth" });
        setCurrentPage(page);
    }

    function setProgressDone(id, step) {
        let progressPoints = document.getElementsByClassName("progress-point");
        for (let i = 0; i < progressPoints.length; i++) {
            progressPoints[i].classList.remove("active");
        }

        let element = document.getElementById(id);
        element.style.display = "none";

        let nextPage = step + 1;
        document.getElementById("progress-" + nextPage).classList.add("active");

        let progressDone = document.createElement("div");
        progressDone.classList.add("progress-point");
        progressDone.setAttribute("id", "progress-" + step + "-done");
        progressDone.innerHTML = '<img src="/Images/done.svg" alt="done">';

        insertAfter(progressDone, element);
    }

    function undoProgressDone(id, step) {
        let progressPoints = document.getElementsByClassName("progress-point");
        for (let i = 0; i < progressPoints.length; i++) {
            progressPoints[i].classList.remove("active");
        }

        let element = document.getElementById(id);
        element.style.display = "block";
        element.classList.add("active");

        let remove = document.getElementById("progress-" + step + "-done");
        remove.remove();
    }

    // @* For adding more market to form 4 *@
    function addMarketForm() {
        numberOfMarketInput++;

        let id = "type-markets-" + numberOfMarketInput;

        let newMarketContainer = document.createElement("div");
        let newMarketLabel = document.createElement("label");
        let newMarketTextarea = document.createElement("textarea");
        let firstMarkedInput = document.getElementById("type-markets-1__input");
        let newMarkedLabelText = firstMarkedInput.dataset.labeltext;
        let placeholderText = firstMarkedInput.dataset.placeholdertext;

        newMarketLabel.setAttribute("for", id + "__input");
        newMarketLabel.classList.add(id + "__label");
        newMarketLabel.innerText =
            newMarkedLabelText + " " + numberOfMarketInput;
        newMarketLabel.style.color = "#4f7d4c";

        newMarketTextarea.setAttribute("id", id + "__input");
        newMarketTextarea.classList.add(id + "__input", "market-input");
        newMarketTextarea.setAttribute("placeholder", placeholderText);

        newMarketContainer.appendChild(newMarketLabel);
        newMarketContainer.appendChild(newMarketTextarea);

        const target = document.getElementById("insert-market__target");
        target.parentNode.insertBefore(newMarketContainer, target);
    }

    function validateActiveForm() {
        let validityArr = [];
        let activeForm = document.getElementsByClassName("active-form");
        let inputs = activeForm[0].querySelectorAll("input,textarea,select");
        let errorMsg = document.getElementsByClassName("error");
        let errorMsgs = [];
        let allLabels = document.getElementsByTagName("label");
        let labels = [];

        hideAllErrors(errorMsg, allLabels, inputs);

        inputs.forEach(el => {
            // console.log("Valid: ", el.checkValidity());
            if (!el.checkValidity()) {
                errorMsgs.push(el.dataset.errorid);
                if (el.dataset.label) {
                    labels.push(el.dataset.label);
                }
                validityArr.push(el);
            }
        });
        if (validityArr.length === 0) {
            return true;
        } else {
            validityArr.forEach(el => {
                el.style.border = "#d33a44 thin solid";
            });
            if (labels.length > 0) {
                labels.forEach(label => {
                    let target = document.querySelector(
                        `label[data-label='${label}']`
                    );
                    target.style.color = "#d33a44";
                });
            }
            if (errorMsgs.length > 0) {
                errorMsgs.forEach(err => {
                    if (document.getElementById(err)) {
                        let target = document.getElementById(err);
                        target.style.display = "block";
                    }
                });
            }
            return false;
        }
    }

    function exportForms() {
        let jsonObject = new Map();

        for (const element of forms) {
            let tempObject = new Map();
            let marketList = [];

            for (const input of element.querySelectorAll(
                "input,textarea,select"
            )) {
                // Skip input if it's a radio button.
                if (input.type === "radio") {
                    continue;
                }
                // Save all markets to a list.
                if (input.id.includes("type-markets-")) {
                    marketList.push(input.value);
                    continue;
                }
                tempObject.set(input.id, input.value);
            }

            if (marketList.length > 0) {
                tempObject.set("type-market", marketList);
            }

            jsonObject.set(element.id, Object.fromEntries(tempObject));
        }
        return sendFormsData(Object.fromEntries(jsonObject));
    }

    function sendFormsData(data) {
        //console.log(endpoint);
        //console.log(JSON.stringify(data));
        return fetch("/sdg/submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                console.log("sendFormsData", data);
                return Promise.resolve(data.IsSuccess);
            });
    }

    function showRecap() {
        let companyRecap = document.getElementById("show-company-info");
        let motivationRecap = document.getElementById("show-motivation-info");

        let companyContainer = document.getElementById("company");
        let companyInputs = companyContainer.querySelectorAll(
            "input,textarea,select"
        );

        let motivationContainer = document.getElementById("motivation");
        let motivationInputs = motivationContainer.querySelectorAll(
            "input,textarea,select"
        );

        addRecaps(companyContainer, companyRecap, companyInputs);
        addRecaps(motivationContainer, motivationRecap, motivationInputs);
    }

    function addRecaps(container, recap, inputs) {
        for (const input of inputs) {
            if (input.type === "radio") {
                continue;
            }

            let companyName = document.createElement("p");
            companyName.classList.add("recapText");
            let label = input.dataset.label;
            let formattedName = container.querySelectorAll(
                `label[data-label='${label}']`
            );
            let labelText = formattedName[0].innerText;

            if (document.getElementById(label)) {
                document.getElementById(
                    label
                ).innerHTML = `<b>${labelText}</b>:<br>${input.value}`;
                document
                    .getElementById(label)
                    .setAttribute(
                        "aria-label",
                        label + ". Svar: " + input.value
                    );
            } else {
                companyName.setAttribute("id", label);
                companyName.setAttribute(
                    "aria-label",
                    label + ". Svar: " + input.value
                );
                companyName.innerHTML = `<b>${labelText}</b>:<br>${input.value}`;

                if (input.value) {
                    recap.appendChild(companyName);
                }
            }
        }
    }

    function validateRecaptcha() {

        var response = grecaptcha.getResponse();

        if (response.length == 0) {
            //reCaptcha not verified
            return false;
        }
        else {
            //reCaptch verifiedk
            return true;
        }
    }

    forms = document.getElementsByClassName("formcontainer");
    forwards = document.getElementsByClassName("forward-btn");
    backs = document.getElementsByClassName("back-btn");
    submit = document.getElementById("submit-form");

    if (forwards.length > 0) {
        // Listeners for navigation
        for (const element of forwards) {
            element.addEventListener("click", () => {
                if (validateActiveForm()) {
                    // cookie();
                    hideAll();
                    showForm(currentPage + 1);
                    setProgressDone("progress-" + currentPage, currentPage);
                    // fillInDataFromCookie();
                    if (currentPage + 1 === 5) {
                        showRecap();
                    }
                }
            });
        }
    }

    if (backs.length > 0) {
        for (const element of backs) {
            element.addEventListener("click", () => {
                // cookie();
                hideAll();
                showForm(currentPage - 1);
                let progressPage = currentPage + 1;
                undoProgressDone("progress-" + progressPage, progressPage);
                // fillInDataFromCookie();
            });
        }
    }

    if (submit) {
        submit.addEventListener("click", () => {
            if (validateRecaptcha() === true) {
                exportForms().then(success => {
                    if (success) {
                        if (validateActiveForm()) {
                            //exportForms();
                            hideAll();
                            showForm(currentPage + 1);
                            document.getElementById("Succes").style.display = "block";
                            // deleteAllSDGCookies();
                        }
                    }
                    else {
                        hideAll();
                        document.getElementById("error").style.display = "block";
                    }
                })
            }
            else {
                showForm(currentPage)
                let target = document.getElementById("recaptcha__error");
                target.style.display = "block";
            }
        });
    }

    // Add market
    addMarket = document.getElementById("insert-market");
    if (addMarket) {
        addMarket.addEventListener("click", () => {
            addMarketForm();
        });
    }

    //Other Sektor / industry (page 1)
    let otherSector = $("select#sector__input");
    if (otherSector) {
        $("select#sector__input").on("change", function (e) {
            let extraInput = document.getElementById("other-sector__input");
            let extraInputLabel = document.getElementsByClassName(
                "other-sector__label"
            );

            if (e.currentTarget.value === "Andet") {
                if (extraInput.dataset.hidden === "true") {
                    extraInput.style.display = "block";
                    extraInputLabel[0].style.display = "block";

                    extraInput.setAttribute("required", "required");
                    extraInput.setAttribute("aria-hidden", "false");
                    extraInputLabel[0].setAttribute("aria-hidden", "false");
                    extraInput.dataset.hidden = "false";
                }
            } else {
                if (extraInput.dataset.hidden === "false")
                    extraInput.style.display = "none";
                extraInputLabel[0].style.display = "none";

                extraInput.removeAttribute("required");
                extraInput.setAttribute("aria-hidden", "true");
                extraInputLabel[0].setAttribute("aria-hidden", "true");
                extraInput.dataset.hidden = "true";
            }
        });
    }

    //Showing and hiding forms with RADIO
    function showHideRadio(radioId, textareaId, labelId, display) {
        let radio = document.getElementById(radioId);
        let textarea = document.getElementById(textareaId);
        if (radio) {
            radio.addEventListener("change", () => {
                textarea.style.display = display;
                if (labelId) {
                    document.getElementById(labelId).style.display = display;
                }
                if (display === "block") {
                    textarea.setAttribute("required", "required");
                    textarea.setAttribute("aria-hidden", "false");
                } else {
                    textarea.removeAttribute("required");
                    textarea.setAttribute("aria-hidden", "true");
                }
            });
        }
    }
    //page 3
    showHideRadio(
        "workingWithSDG-yes__input",
        "workingWithSDG__input",
        false,
        "block"
    );
    showHideRadio(
        "workingWithSDG-no__input",
        "workingWithSDG__input",
        false,
        "none"
    );
    //page 4
    showHideRadio(
        "alreadyExporting-yes__input",
        "exporting_abroad__input",
        "exporting_abroad__label",
        "block"
    );
    showHideRadio(
        "alreadyExporting-no__input",
        "exporting_abroad__input",
        "exporting_abroad__label",
        "none"
    );

    function showHiddenInput(
        radioId,
        textareaId,
        labelId,
        display,
        textareaData
    ) {
        let radio = document.getElementById(radioId);
        let textarea = document.getElementById(textareaId);
        if (radio) {
            textarea.style.display = display;
            if (labelId) {
                document.getElementById(labelId).style.display = display;
            }
            if (display === "block") {
                textarea.setAttribute("required", "required");
                textarea.setAttribute("aria-hidden", "false");
            } else {
                textarea.removeAttribute("required");
                textarea.setAttribute("aria-hidden", "true");
            }
            textarea.value = textareaData;
        }
    }
});
